import { executeQuery } from 'common/gql';
import logoutMutation from 'common/gql/mutation/user/logout.gql';
import { captureError } from 'common/utils/error-reporter';

export const LOGOUT_BANNER_STORAGE_KEY = 'withAutoLogoutBanner';

export const getWithAutoLogoutBanner = () => {
  try {
    const withAutoLogoutBanner = window.localStorage.getItem(LOGOUT_BANNER_STORAGE_KEY);

    return !!withAutoLogoutBanner;
  } catch {
    return false;
  }
};

export const clearWithAutoLogoutBanner = () => {
  try {
    window.localStorage.removeItem(LOGOUT_BANNER_STORAGE_KEY);
  } catch {
    return;
  }
};

export const saveWithAutoLogoutBanner = () => {
  try {
    window.localStorage.setItem(LOGOUT_BANNER_STORAGE_KEY, 'true');
  } catch {
    return;
  }
};

export const performLogout = async (redirectUrl: string) => {
  try {
    await executeQuery<void>({
      query: logoutMutation,
    });

    clearWithAutoLogoutBanner();
    window.location.href = redirectUrl;
  } catch (error) {
    captureError(`The logout attempt was unsuccessful. ${error}`);
  }
};
